import KickImage from 'Reuseables/KickImage';
import { FC, useEffect, useRef, useState } from 'react';
import { Form } from 'react-bootstrap';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { toast } from 'react-toastify';
import {
  doFetchProfile,
  doSignUp,
  doSocialSignIn,
} from '../../../actions/authAction';
import {
  doFetchCountries,
  doFetchProvinces,
} from '../../../actions/postalCodeAction';
import { isValidPasswordNew } from '../../../helpers/regex';
import HideEye from '../../../images/hide-eyes-input.png';
import RegisterImage from '../../../images/register-left.png';
import ShowEye from '../../../images/show-eyes-input.png';
import DataPostalCodeInterface, {
  CountriesInterface,
  ProvinceInterface,
} from '../../../interface/reducers/postalCode';
import SurveyModal from '../../Modals/SurveyModal';
import ModalOtp from 'Pages/Auth/Registration/Components/ModalOtp';
import InputNumber from 'Reuseables/InputNumber';
import { Col, Row } from 'antd';
import useRegisterWithOtp, {
  TSubmitRegisterDraftResponseDataError,
} from 'Pages/Auth/Registration/Hooks/useRegisterWithOTP';
import useFetchPhoneCountryCode, {
  IOptions,
} from 'Pages/Auth/Registration/Hooks/useFetchPhoneCountryCode';
import { useOutsideAlerter } from 'helpers/dom';
import { IconContext } from 'react-icons';
import { GrFormDown } from 'react-icons/gr';
interface History {
  push: (args: string) => any;
  replace: (args: string) => any;
}

interface Props {
  onClick: () => any;
}

type stateToProps = {
  dataPostalCode: DataPostalCodeInterface;
  dataMenu: any;
};

interface FacebookUser {
  id: number;
  email: string;
  typed_email: string;
  type: string;
  oauth_token: string;
  name: string;
}

interface RegisterData {
  email: string;
  password: string;
  seller_location_id: string;
}

interface socialLogin {
  id: number;
  email: string;
  typed_email: string;
  oauth_token: number;
  type: string;
  name: string;
  accessToken: string;
}

type PageRegister = {
  history: History;
  countries: CountriesInterface[];
  provinces: ProvinceInterface[];
  register(args: RegisterData): any;
  doFetchProfile(): any;
  socialLogin(args: socialLogin): any;
  getCountries: () => any;
  getProvinces: (country: string) => any;
  countdown_modal?: boolean;
};

interface GoogleUserData {
  googleId: number;
  email: string;
  name: string;
}

interface GoogleUser {
  tokenId: number;
  profileObj: GoogleUserData;
}

const PageRegisterV3: FC<PageRegister> = ({
  history,
  getCountries,
  countdown_modal,
}) => {
  const [email, setEmail] = useState('');
  const [phoneCountryCode, setPhoneCountryCode] = useState('+62');
  const [phoneNumber, setPhoneNumber] = useState('');
  const [password, setPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [showSurveyModal, setShowSurveyModal] = useState(false);
  const [firstRender, setFirstRender] = useState(true);
  const [errorEmail, setErrorEmail] = useState('');
  const [errorPhoneNumber, setErrorPhoneNumber] = useState('');
  const [errorPassword, setErrorPassword] = useState('');
  const [errorConfirmPassword, setErrorConfirmPassword] = useState('');
  const [showPassword, setShowPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);
  const [isDisabled, setIsDisabled] = useState(true);
  const [isOpenModalOtp, setIsOpenModalOtp] = useState(false);

  const [phoneInput, setPhoneInput] = useState('+62');
  const [oldPhoneNumberList, setOldPhoneNumberList] = useState<IOptions[]>([]);
  const [phoneNumberLists, setPhoneNumberList] = useState<IOptions[]>([]);

  const [phoneOpen, setPhoneOpen] = useState(false);
  const wrapperRefPhone = useRef(null);
  useOutsideAlerter(wrapperRefPhone, () => setPhoneOpen(false));

  const {
    isPosting,
    submitRegisterDraft,
    sendOtpEmail,
    sendOtpPhoneNumber,
    submitVerifyOtp,
  } = useRegisterWithOtp();

  const { options: phoneNumberList } = useFetchPhoneCountryCode({});

  useEffect(() => {
    setPhoneNumberList(phoneNumberList);
    setOldPhoneNumberList(phoneNumberList);
  }, [phoneNumberList]);

  useEffect(() => {
    getCountries();
    setFirstRender(false);
  }, []);

  useEffect(() => {
    if (!firstRender) {
      if (!password) {
        setErrorPassword('Please insert your password.');
      } else if (!isValidPasswordNew(password)) {
        setErrorPassword(
          'Your password at least contain 8 characters include (. ! -) and combine with capital letter or numeric.',
        );
      } else if (password && password !== confirmPassword) {
        setErrorConfirmPassword(`Password confirmation doesn't match`);
      } else {
        setErrorPassword('');
      }
    }
  }, [password, confirmPassword]);

  useEffect(() => {
    if (errorEmail !== '' || errorPassword !== '' || errorPhoneNumber !== '') {
      setIsDisabled(true);
      return;
    }

    if (password && password !== confirmPassword) {
      setIsDisabled(true);
      return;
    }

    if (
      email &&
      phoneCountryCode &&
      phoneNumber &&
      password &&
      confirmPassword
    ) {
      setIsDisabled(false);
    }
  }, [
    email,
    password,
    confirmPassword,
    errorEmail,
    errorPassword,
    errorPhoneNumber,
  ]);

  const onChangePhoneInput = (e) => {
    let inputValue = e.target.value.replace('+', '');
    setPhoneInput(inputValue);
    const newPhoneList = oldPhoneNumberList.filter((t) =>
      t.value.toLowerCase().includes(inputValue.toLowerCase()),
    );
    setPhoneNumberList(newPhoneList);
  };

  function onChangeEmail(e: any) {
    setEmail(e.target.value);
    setErrorEmail('');
  }

  function togglePassword() {
    setShowPassword(!showPassword);
  }

  function toggleConfirmPassword() {
    setShowConfirmPassword(!showConfirmPassword);
  }

  function onChangePassword(e: any) {
    let value = e.target.value;
    setPassword(value);
    setErrorPassword('');
    setErrorConfirmPassword('');
  }

  function onChangeConfirmPassword(e: any) {
    setConfirmPassword(e.target.value);
    setErrorConfirmPassword('');
  }

  function goToLoginPage() {
    history.push('/login');
  }

  const errorToast = (message: string) => {
    toast.error(message, {
      position: 'top-right',
      autoClose: 5000,
      closeOnClick: true,
      pauseOnHover: true,
    });
  };

  const signUp = async (e: any) => {
    e.preventDefault();
    if (isDisabled || isPosting.registerDraft) return null;
    if (!errorEmail && !errorPassword && !errorPhoneNumber) {
      setErrorEmail('');
      setErrorPassword('');
      setErrorPhoneNumber('');
      const mobile_number = `${phoneCountryCode}${phoneNumber}`;
      const res = await submitRegisterDraft({
        email,
        password,
        password_confirmation: confirmPassword,
        mobile_number,
      });

      if (!res.isSuccess) {
        const errorDetail =
          res?.detail as unknown as TSubmitRegisterDraftResponseDataError['error']['errors'];
        const errorEmail = errorDetail?.email;
        const errorPhoneNumber = errorDetail?.mobile_number;

        if (errorEmail) {
          setErrorEmail(errorEmail?.[0]);
          if (!errorPhoneNumber) return;
        }

        if (errorPhoneNumber) {
          setErrorPhoneNumber(errorPhoneNumber?.[0]);
          return;
        }

        errorToast(res.message);
        return;
      }
      setIsOpenModalOtp(true);
    }
  };

  return (
    <div
      style={{ paddingTop: window.screen.availWidth > 480 ? '80px' : '89px' }}
      className={
        countdown_modal
          ? 'page-register-v3 is-countdown-modal'
          : 'page-register-v3'
      }
    >
      <div className="misc-register">
        <KickImage src={RegisterImage} alt="Register image" />
        <h4>What are you waiting for?</h4>
        <h5>Immerse yourself in the latest trend in fashion.</h5>
      </div>
      <div className="main-register">
        <div className="register-title">
          <h5>Register</h5>
          <p>
            Already have an account?{' '}
            <span onClick={() => goToLoginPage()}>Login here</span>
          </p>
        </div>
        <Form onSubmit={signUp}>
          <div className="form-register">
            <input
              value={email}
              onChange={onChangeEmail}
              className={errorEmail ? 'error' : ''}
              type="email"
              placeholder="Email Address"
            />
            {errorEmail && <p className="error-message">{errorEmail}</p>}

            <Row>
              <Col span={4} className="phone-input">
                {/* <select
                  value={phoneCountryCode}
                  onChange={(e) => {
                    setPhoneCountryCode(e.target.value);
                  }}
                  style={{
                    backgroundPositionX: '70%',
                    backgroundSize: '10px 6px',
                    ...(errorPhoneNumber && {
                      borderWidth: '2px',
                      borderColor: '#dc3545',
                    }),
                  }}
                >
                  {phoneNumberList.map((code) => {
                    return (
                      <option key={code.value} value={code.value}>
                        {code.label}
                      </option>
                    );
                  })}
                </select> */}
                <div className="wrapper-group">
                  <div
                    className={'text-box group mt-0'}
                    onClick={() => setPhoneOpen(true)}
                  >
                    <InputNumber
                      value={phoneInput}
                      onChange={onChangePhoneInput}
                      placeholder="Code"
                    />
                    <IconContext.Provider
                      value={{ color: '#242424', size: '15px' }}
                    >
                      <span className={'icon-dropdown'}>
                        <GrFormDown />
                      </span>
                    </IconContext.Provider>
                  </div>
                  {phoneOpen && (
                    <div
                      ref={wrapperRefPhone}
                      className={'search-country-container mt-0'}
                      style={{ top: 50 }}
                    >
                      {phoneNumberLists.map((p, i) => {
                        const onClick = () => {
                          setPhoneCountryCode(p.value);
                          setPhoneOpen(false);
                          setPhoneInput(p.value);
                          setPhoneNumberList(oldPhoneNumberList);
                        };
                        return (
                          <div
                            className={`mt-0 search-country-item${
                              p.value === phoneCountryCode ? ' selected' : ''
                            }`}
                            onClick={onClick}
                            key={i}
                          >
                            <p>{p.value}</p>
                          </div>
                        );
                      })}
                    </div>
                  )}
                </div>
              </Col>
              <Col span={19} offset={1}>
                <InputNumber
                  value={phoneNumber}
                  autoComplete="off"
                  onChange={(e) => {
                    setErrorPhoneNumber('');
                    setPhoneNumber(e.target.value);
                  }}
                  placeholder="Phone Number"
                  className={errorPhoneNumber ? 'error' : ''}
                />
              </Col>
            </Row>
            {errorPhoneNumber && (
              <p className="error-message">{errorPhoneNumber}</p>
            )}
            <div
              className="container-password"
              style={{ position: 'relative' }}
            >
              <input
                value={password}
                onChange={onChangePassword}
                className={errorPassword ? 'error' : ''}
                placeholder="Password"
                type={showPassword ? 'text' : 'password'}
              />
              <KickImage
                onClick={() => togglePassword()}
                alt="eyes"
                src={showPassword ? ShowEye : HideEye}
              />
            </div>
            {errorPassword && <p className="error-message">{errorPassword}</p>}
            <div
              className="container-confirm-password"
              style={{ position: 'relative' }}
            >
              <input
                type={showConfirmPassword ? 'text' : 'password'}
                autoComplete="off"
                value={confirmPassword}
                onChange={onChangeConfirmPassword}
                placeholder="Confirm Password"
              />
              <KickImage
                onClick={() => toggleConfirmPassword()}
                alt="eyes"
                src={showConfirmPassword ? ShowEye : HideEye}
              />
            </div>
            {errorConfirmPassword && (
              <p className="error-message">{errorConfirmPassword}</p>
            )}
          </div>
          <div className="tnc">
            <h4>
              By registering, I agree to Kick Avenue's{' '}
              <span onClick={() => history.push('/helps/terms-conditions')}>
                Terms and Conditions
              </span>{' '}
              and{' '}
              <span onClick={() => history.push('/helps/privacy-policy')}>
                Privacy Policy
              </span>
            </h4>
          </div>
          <div className="btn-register">
            <button
              className={`${
                isDisabled || isPosting.registerDraft ? 'disabled' : null
              }`}
              type="submit"
            >
              Register
            </button>
          </div>
        </Form>
        <div className="misc-description">
          <h4>Your data will be protected and will not be shared</h4>
        </div>
      </div>
      <SurveyModal
        show={showSurveyModal}
        handleShowSurvey={() => {
          setShowSurveyModal(!showSurveyModal);
          history.replace('/');
        }}
      />
      {isOpenModalOtp && (
        <ModalOtp
          open={isOpenModalOtp}
          phoneNumber={phoneNumber}
          email={email}
          password={password}
          phoneCountryCode={phoneCountryCode}
          onCancel={() => setIsOpenModalOtp(false)}
          sendOtpEmail={sendOtpEmail}
          sendOtpPhoneNumber={sendOtpPhoneNumber}
          submitVerifyOtp={submitVerifyOtp as unknown as any}
          isPosting={isPosting.verifyOtp}
        />
      )}
    </div>
  );
};

interface Register {
  email: string;
  password: string;
  seller_location_id: number;
}

const mapStateToProps = (state: stateToProps) => {
  return {
    countries: state.dataPostalCode.countries.data,
    provinces: state.dataPostalCode.provinces.data,
    countdown_modal: state.dataMenu.countdown_modal,
  };
};

const mapDispatchToProps = (dispatch: any) => ({
  getCountries: () => dispatch(doFetchCountries()),
  getProvinces: (country: string) => dispatch(doFetchProvinces(country)),
  register: ({ email, password, seller_location_id }: Register) =>
    dispatch(doSignUp({ email, password, seller_location_id })),
  doFetchProfile: () => dispatch(doFetchProfile()),
  socialLogin: (user: Object) => dispatch(doSocialSignIn(user)),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(withRouter(PageRegisterV3));
